namespace TabAurous.Inventory {
    export interface CertificationReturnTaxForm {
        TransId: Serenity.StringEditor;
        HSN: Serenity.StringEditor;
        ProductTypeId: Serenity.IntegerEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxId: Serenity.IntegerEditor;
        TaxRate: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
    }

    export class CertificationReturnTaxForm extends Serenity.PrefixedContext {
        static formKey = 'CertificationReturn.CertificationReturnTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CertificationReturnTaxForm.init)  {
                CertificationReturnTaxForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(CertificationReturnTaxForm, [
                    'TransId', w0,
                    'HSN', w0,
                    'ProductTypeId', w1,
                    'NetAmount', w2,
                    'TaxId', w1,
                    'TaxRate', w2,
                    'TaxAmount', w2
                ]);
            }
        }
    }
}
